import {createContext} from "react"
export const StProjectsContext = createContext({
    stProjectsContext: null,
    setStProjectsAction: () => {},
})